var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from 'react';
import { RouterBridge, useOnAfterRouteChange } from '../../../../../infra/routing';
import { useSession } from '../../../../../infra/session';
import { buildCampaignConfigurationUrl, buildCampaignContentUrl, buildCampaignReviewUrl, buildCampaignTypeUrl, } from '../../../utils/url-builders';
import { t } from '../../../../../infra/i18n';
var getTypeStep = function () { return ({
    label: t('engage:campaign_builder.steps.type'),
    order: 1,
    automationIdPart: 'type',
}); };
var getConfigurationStep = function () { return ({
    label: t('engage:campaign_builder.steps.options'),
    order: 2,
    automationIdPart: 'options',
}); };
var getContentStep = function () { return ({
    label: t('engage:campaign_builder.steps.content'),
    order: 3,
    automationIdPart: 'content',
}); };
var getReviewStep = function () { return ({
    label: t('engage:campaign_builder.steps.review'),
    order: 4,
    automationIdPart: 'review',
}); };
var getAllSteps = function () { return [getTypeStep(), getConfigurationStep(), getContentStep(), getReviewStep()]; };
var getActiveStep = function (params) {
    var builderParams = {
        campaignId: params.campaignId,
        session: params.session,
    };
    var campaignTypeRoute = buildCampaignTypeUrl(builderParams);
    if (params.pathname === campaignTypeRoute) {
        return getTypeStep();
    }
    var configurationRoute = buildCampaignConfigurationUrl(builderParams);
    if (params.pathname === configurationRoute) {
        return getConfigurationStep();
    }
    var contentRoute = buildCampaignContentUrl(builderParams);
    if (params.pathname === contentRoute) {
        return getContentStep();
    }
    var reviewRoute = buildCampaignReviewUrl(builderParams);
    if (params.pathname === reviewRoute) {
        return getReviewStep();
    }
    return null;
};
var buildSteps = function (params) {
    var activeStep = getActiveStep(params);
    var allSteps = getAllSteps(); // ✅ t() called at runtime
    return allSteps.map(function (step) { return (__assign(__assign({}, step), { completed: step.order < (activeStep === null || activeStep === void 0 ? void 0 : activeStep.order), active: step.order === (activeStep === null || activeStep === void 0 ? void 0 : activeStep.order), automationIdPart: step.automationIdPart })); });
};
export var useProgressIndicator = function () {
    var session = useSession().data;
    var _a = useState([]), steps = _a[0], setSteps = _a[1];
    useEffect(function () {
        if (session) {
            var nextSteps = buildSteps({
                pathname: window.location.pathname,
                campaignId: RouterBridge.getParamsOnce().params.campaignId,
                session: session,
            });
            setSteps(nextSteps);
        }
    }, [session]);
    useOnAfterRouteChange(function () {
        // fixme: for some reason, the pathname is not updated immediately after the route change
        // so we need to wait for a short period of time before we can get the correct pathname
        setTimeout(function () {
            var nextSteps = buildSteps({
                pathname: window.location.pathname,
                campaignId: RouterBridge.getParamsOnce().params.campaignId,
                session: session,
            });
            setSteps(nextSteps);
        }, 50);
    }, [session]);
    return { steps: steps };
};
